import { IoLogoGooglePlaystore, IoMailOutline, IoLogoFacebook, IoLogoInstagram } from 'react-icons/io5';

import './SocialIcons.css';

const SocialIcons = (props) => {
  return (
    <div className='main-container__social-icons'>
      <a
        className='main-container__social-icons-icon'
        href='mailto:info@beveikradijas.com'
        target='_blank'
        rel='noreferrer'
      >
        <IoMailOutline color='#fff' size={props.width > 376 ? 35 : 25} />
      </a>
      <a
        className='main-container__social-icons-icon'
        href='https://www.facebook.com/beveikradijas/'
        target='_blank'
        rel='noreferrer'
      >
        <IoLogoFacebook color='#fff' size={props.width > 376 ? 30 : 25} />
      </a>
      <a
        className='main-container__social-icons-icon'
        href='https://www.instagram.com/beveikradio/'
        target='_blank'
        rel='noreferrer'
      >
        <IoLogoInstagram color='#fff' size={props.width > 376 ? 30 : 25} />
      </a>
      <a
        className='main-container__social-icons-icon'
        href='https://play.google.com/store/apps/details?id=com.radijas.beveik'
        target='_blank'
        rel='noreferrer'
      >
        <IoLogoGooglePlaystore color='#fff' size={props.width > 376 ? 30 : 25} />
      </a>
    </div>
  );
};

export default SocialIcons;
